import moment from "moment";
import { createSelector } from "reselect";
import { systemActivationFetcher } from "./services";

export const getSystemActivationDetails = createSelector(
  systemActivationFetcher.selector,
  ({ result }) => {
    if (!result) {
      return;
    }

    const daysRemaining = moment(result?.status?.expiresAt)
      .utc()
      .diff(moment().utc(), "days");

    return {
      state: result?.status?.state?.toLowerCase() || "",
      daysRemaining,
      isAboutToExpire: daysRemaining <= 7,
    };
  }
);
